import React from "react";

function OfferSettings({ action, value }) {
  return (
    <>
      <section
        id="wrapperModal"
        className="modal-area modal"
        style={{ display: value ? "flex" : "none" }}
      >
        <div
          onClick={action}
          className={`single-profile-away ${value ? "active" : ""}`}
        ></div>
        <div className="modal-single-wrap">
          <div className="closePopup" onClick={action}>
            <i className="fa-solid fa-xmark"></i>
          </div>
          <div className="modal-title">
            <h3>Offer Settings</h3>
            <p>
              Properties show up underneath your item, are clickable, and can be
              filtered in your collection's sidebar.
            </p>

            <form action="#">
              <div className="row">
                <div className="col-xl-6 p-0">
                  <div className="modal-input-wrap">
                    <i className="fa-solid fa-xmark"></i>
                    <label> Type </label>
                    <input type="text" placeholder="Character" />
                  </div>

                  <div className="modal-input-wrap modal-input-wrap2">
                    <i className="fa-solid fa-xmark"></i>
                    <input type="text" placeholder="Character" />
                  </div>
                  <div className="modal-btn">
                    <a className="btn" href="#">
                      Add more
                    </a>
                  </div>
                </div>

                <div className="col-xl-6 p-0">
                  <div className="modal-input-wrap">
                    <label> Name </label>
                    <input type="text" placeholder="Character" />
                  </div>

                  <div className="modal-input-wrap">
                    <input type="text" placeholder="Character" />
                  </div>
                </div>

                <div className="popup-bottom-title text-center">
                  <a className="btn" href="#">
                    Save
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default OfferSettings;
